// Copyright (c) 2021 Deere & Company

import './index.scss';

import AtpCalendarList from './atpCalendarList';
import AuthenticatedPage from '../../common/components/authenticated-page';
import React from 'react';

function AtpCalendarListPage () {

    return (
        <AuthenticatedPage className="atp-page atp-calendar-list-page">
            <AtpCalendarList />
        </AuthenticatedPage>
    );

}
AtpCalendarListPage.displayNAme = 'AtpCalendarListPage';

export default AtpCalendarListPage;
